import React, { Component } from 'react';
import { Container, Row, Col} from 'reactstrap';
import PaymentHeader from 'components/PaymentContainer/payment_header';
import PaymentList from 'components/PaymentContainer/PaymentList';
import PaymentView from 'components/PaymentContainer/PaymentView';
import { connect } from 'react-redux';
import { changePaymentView,toggleTermsAndCondition, callCardMetaDataAPI, setTransactionAmount} from 'actions/payment';

import { filterAndSortPayMenu } from 'lib/fp-utility';
import { withTranslation } from 'react-i18next';
//import { StaticPaymentMethod} from '../Common'
import StaticPaymentModal from 'components/FDModal/static-payment'
import GlobalLoaderModal from "components/FDModal/global-loader";
class PaymentContainer extends Component {
    
    changePayment = this.changePayment.bind(this);
    state = {
        visibleCardForm : false,
        loader: false,
        errorMessage : ''
    }
    componentDidMount(){
        // if(window.innerWidth < 992){
        //     this.props.changePaymentView('selectedPayment', null)
        // }
        this.props.toggleTermsAndCondition(true)
    }

    async changePayment(selectedPayment) {
        if(!this.props.disableAllPaymentView){
            this.props.changePaymentView(selectedPayment)
        }
    }
    showResults = async (values) => {
        this.setState({loader: true})
        let data = []
        const objectArray = Object.entries(values);
        await objectArray.forEach(([key, value]) => {
            data.push({"param": key, "value": value})
        });
        await callCardMetaDataAPI('STATIC_PAYMENT', data).then((resp) =>{
            if(resp.data && resp.data.response && resp.data.response.errorCode){
                this.setState({loader: false, errorMessage : resp.data.response.errorMessage})

            } else {
                this.props.setTransactionAmount(values.txnamount)
                this.setState({loader: false, visibleCardForm: true, errorMessage: ''})
            }

        })
    }

    render() {
        const { savedCards, t , disableAllPaymentView, integrationType } = this.props
        const menuListCount = this.props.paymentList.length + (savedCards ? savedCards.length : 0)
        const filteredAndSortedPaymentList = filterAndSortPayMenu(this.props.paymentList)
        return(
            <>
                <PaymentHeader t={t} selectedPayment={this.props.selectedPayment} menuListCount={menuListCount} />
                <Container>
                    {
                        this.props.mBanner &&
                        <Row>
                            <Col xs="12">
                                <div className="alert-info">
                                    <p className="text-16 textColorHeader">{this.props.mBanner}</p>
                                </div>
                            </Col>
                        </Row> 
                    }
                    <Row>
                        {
                            menuListCount > 1 &&
                            <Col lg="4">
                                <PaymentList 
                                    paymentList={filteredAndSortedPaymentList} 
                                    selectedPayment={this.props.selectedPayment}
                                    changePayment={this.changePayment}
                                    siEnabled={this.props.siEnabled}
                                    disableAllPaymentView={disableAllPaymentView}
                                    t={t}
                                />
                            </Col>
                        }
                        <Col sm="12" lg={menuListCount > 1 ? 8 : 12} className="mob-mb-5 mob-accordion">
                            <PaymentView 
                                changePayment={this.changePayment}
                                selectedPayment={this.props.selectedPayment}
                                paymentList={filteredAndSortedPaymentList}
                                merchantInfo={this.props.mrch_tnc_details}
                                t={t}
                                key={this.state.loader}
                            />
                        </Col>

                    </Row>

                </Container>
                { ( integrationType === 'MERCHANT_STATIC_PAYMENT_INTEGRATION' && !this.state.visibleCardForm ) &&   


                    <StaticPaymentModal wrapperClassName="staticPaymentModal" data={this.props.staticUrl.params}  onSubmit={this.showResults}  error={this.state.errorMessage}/>
 
                }
                { this.state.loader && <GlobalLoaderModal transaction={false} /> }

            </>
        );
    }

}

const mapStateToProps = state => {
    const {disableAllPaymentView, savedCards, selectedPayment, mrch_tnc_details, globalConfig: {mConfig: { mPaymentModes: paymentMenu, retryCount, mBanner, mFrmBannerDate, mToBannerDate, integrationType, staticUrl} }, siEnabled} = state.fdData;
    const paymentList = (savedCards && savedCards.length)>0 ? ['SC', ...paymentMenu] : paymentMenu
    return { disableAllPaymentView, selectedPayment, savedCards, retryCount, mBanner, mFrmBannerDate, mToBannerDate, paymentList, siEnabled, mrch_tnc_details, integrationType, staticUrl }
}

const PaymentContainerWtihTrans = withTranslation("translations")(PaymentContainer)
export default connect(mapStateToProps, { changePaymentView,toggleTermsAndCondition, callCardMetaDataAPI, setTransactionAmount })(PaymentContainerWtihTrans);